import { Outlet } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAppConfig } from '@shared/app/app-config';

/**
 * Centered, single-column shell for unauthenticated flows (login, password
 * reset, etc.). Feature pages render into the <Outlet/>.
 */
export function AuthLayout() {
  const { name } = useAppConfig();
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-muted/30 px-4 py-10">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
        className="w-full max-w-md"
      >
        <div className="mb-8 flex flex-col items-center text-center">
          <img src="/favicon.svg" alt="" className="mb-3 size-10 rounded-lg" />
          <h1 className="text-2xl font-semibold tracking-tight text-foreground">HEXAUNITY</h1>
          <p className="mt-1 text-sm text-muted-foreground">{name}</p>
        </div>
        <div className="rounded-xl border border-border bg-card p-6 shadow-sm">
          <Outlet />
        </div>
      </motion.div>
    </div>
  );
}
